export const OVERCLAIM_FILTER_STATUS = {
    OVERCLAIM: 'Overclaim',
    DISPUTE: 'Dispute',
    RESOLVED: 'Resolved',
    MERGED: 'Merged',
    CANCELED: 'Canceled',
}

export type OverclaimFilterStatus = (typeof OVERCLAIM_FILTER_STATUS)[keyof typeof OVERCLAIM_FILTER_STATUS]

export const getOverclaimStatusText = (status?: string) => {
    switch (status) {
        case 'OVERCLAIM':
            return 'Overclaim'
        case 'DISPUTE':
            return 'Dispute'
        case 'RESOLVED':
            return 'Resolved'
        case 'MERGED':
            return 'Merged'
        case 'CANCELED':
            return 'Canceled'
        default:
            return null
    }
}

export const getOverclaimToolTip = (status?: string) => {
    switch (status) {
        case 'OVERCLAIM':
            return 'This work has submitted shares totaling over 100%.'
        case 'DISPUTE':
            return 'This work is in dispute.'
        case 'RESOLVED':
            return 'This work is no longer in overclaim.'
        case 'MERGED':
            return 'This work has been merged into another work.'
        case 'CANCELED':
            return 'The overclaim on this work has been cancelled.'
        default:
            return 'Overclaim'
    }
}
